module.exports = __webpack_public_path__ + "static/pokemon-ef1d652e749165ae6cba037c85ef30f8.webm";